/* eslint-disable react/require-default-props */
import React from "react";
import MaskedInput from "react-text-mask";
import { FieldProps } from "formik";
import { cx, css } from "@emotion/css";
import { createNumberMask } from "text-mask-addons";
import formGroupStyles from "../css/formgroup.module.css";

interface OtherProps {
  label: string;
  allowDecimal?: boolean;
  integerLimit: number;
  includeThousandsSeparator?: boolean;
}

type FieldTextMoneyProps = FieldProps & OtherProps;

const FieldTextMoney = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, setFieldValue, handleChange, setFieldTouched },
  allowDecimal = true,
  includeThousandsSeparator = true,
  label,
  integerLimit
}: FieldTextMoneyProps) => {
  const fieldClasses = cx(
    formGroupStyles["form-group"],
    touched[field.name] && errors[field.name] ? formGroupStyles.error : ""
  );

  return (
    <div className={fieldClasses}>
      <label htmlFor={field.name}>{label}</label>
      <div>
        <div>
          <span>$ </span>
          <MaskedInput
            mask={value => {
              if (value === "0") return [/1-9/];
              return createNumberMask({
                allowDecimal,
                integerLimit,
                includeThousandsSeparator,
                prefix: ""
              })(value);
            }}
            className={css`
              width: 80% !important;
            `}
            type="text"
            spellCheck="false"
            id={field.name}
            onChange={e => {
              setFieldValue(
                field.name,
                parseFloat(e.currentTarget.value.replace(/,/g, ""))
              );
            }}
            onBlur={() => {
              setFieldTouched(field.name);
            }}
          />
        </div>
        <div className={formGroupStyles["error-messages"]}>
          {touched[field.name] && errors[field.name] && (
            <div id={`${field.name}ErrorMessage`}>
              {errors[field.name] as React.ReactNode}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FieldTextMoney;
